export enum ActionType {
  CheckIn = 'check-in',
  FirstDeviceCheckIn = 'first-device-check-in',
  MonthlyDeviceCheckIn = 'monthly-device-check-in',
  MonthlyMedicationCheckIn = 'monthly-medication-check-in',
  MoodCheckIn = 'mood-check-in',
  Renewal = 'renewal',
  WeeklyDeviceCheckIn = 'weekly-device-check-in',
  WeeklyMedicationCheckIn = 'weekly-medication-check-in'
}

// Shared by the legacy wm and new surveys survey-details contracts — a single
// enum identity keeps the two payload types structurally compatible where they
// overlap. wm.types re-exports these for its existing consumers.
export enum DosagePreference {
  Current = 'current',
  Decrease = 'decrease',
  Increase = 'increase'
}

export enum LabsStatus {
  Completed = 'completed',
  Ordered = 'ordered',
  Required = 'required'
}

export enum LabsType {
  Ash = 'ash',
  Elation = 'elation'
}

// 'TRT' = Men's Health testosterone therapy (distinct from 'MH' = Mental Health).
export type DrugClass = 'GLP-1' | 'TT' | 'MH' | 'WH' | 'TRT';

export interface Survey {
  _id: string;
  completedAt: string;
  drugClass: DrugClass;
  hasMissingData?: boolean;
  orderId: string;
  programId: string;
  /**
   * When the patient's "remind me later" reminder ends.
   * Set only on snoozed surveys; absent or `null` means not snoozed.
   */
  snoozedUntil?: string | null;
  type: ActionType;
}
